import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import {Link} from 'react-router';
import Api, {Utils} from '../../Api/index';
import {optimizeImageUrl} from '../../lib/Images';
import {simplifyLargeNumber} from '../../lib/StringUtils';

const marketplaceImageWidth = 236;
const marketplaceImageHeight = 236;
const marketplaceImageAspectRatio = marketplaceImageWidth / marketplaceImageHeight;

// TODO make these pure presentation components and have admin wrapper
export default class MarketplaceProduct extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    product: PropTypes.object.isRequired,
    generateProductUrl: PropTypes.func,
    brand: PropTypes.object.isRequired,
    retailerToken: PropTypes.string.isRequired,
    onBrandClick: PropTypes.func,
    onImageLoad: PropTypes.func,
    imageLoadDelay: PropTypes.number,
    isEmployee: PropTypes.bool,
    cartEntry: PropTypes.array,
    minimize: PropTypes.bool
  };

  constructor(props) {
    super(props);

    Utils.bindThis(
      this,
      [
        'onImageLoad',
        'imageList',
        'wholesaleInfo',
        'extraContent',
        'onBrandClick',
        'onActiveClick',
        'onManualRecommendationClick'
      ]
    );

    this.state = {
      product: props.product,
      brand: props.brand
    };
  }

  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      product: nextProps.product
    });
  }

  onImageLoad() {
    if (this.props.onImageLoad) {
      let delay = this.props.imageLoadDelay || 0;
      setTimeout(() => {
        this.props.onImageLoad(this)
      }, delay);
    }
  }

  imageList(product) {
    let imageList = [];
    if (product.images) {
      product.images.forEach(image => {
        imageList.push(image);
      });
    }

    if (product.options) {
      product.options.forEach(productOption => {
        if (!productOption.images) return;

        productOption.images.forEach(image => {
          imageList.push(image);
        });
      });
    }

    return imageList;
  }

  onBrandClick(event) {
    if (!this.props.onBrandClick || event.defaultPrevented) return;

    event.preventDefault();
    this.props.onBrandClick(this.props.brand);
  }

  onActiveClick(event) {
    event.preventDefault();

    let product = this.state.product;
    product.active = !product.active;
    return Api.saveProduct(product).then(
      () => {
        this.setState({product: product});
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  onManualRecommendationClick(event) {
    event.preventDefault();

    let retailerToken = this.props.retailerToken;
    if (!retailerToken) return;

    let product = this.state.product;
    let manualRecommendation = product.manual_recommendation;
    let promise = null;
    if (manualRecommendation) {
      promise = Api.retailerRemoveRecommendation(retailerToken, product.token);
    } else {
      promise = Api.retailerAddRecommendation(retailerToken, product.token);
    }

    return promise.then(
      () => {
        product.manual_recommendation = !manualRecommendation;
        this.setState({product: product});
      },
      (error) => {
        alert(error.response.message);
      }
    );
  }

  wholesaleInfo() {
    let product = this.state.product;
    let productOption = (product.options && product.options.length > 0) ? product.options[0] : {
      unit_multiplier: 1,
      wholesale_price_cents: null
    };

    let unitMultiplier = productOption.unit_multiplier;
    let retailPrice = productOption.retail_price_cents ? '$' + Utils.formatCents(productOption.retail_price_cents, true) : null;
    let wholesalePrice = productOption.wholesale_price_cents ? '$' + Utils.formatCents(productOption.wholesale_price_cents, true) : null;

    return {
      wholesale_price: wholesalePrice,
      retail_price: retailPrice,
      unit_multiplier: unitMultiplier,
      collection_size: null,
    };
  }

  extraContent() {
    if (this.props.cartEntry) {
      let quantity = this.props.cartEntry.reduce((count, entry) => {
        return count + entry.quantity;
      }, 0);

      return <div className="cart-contents"><span>{quantity}</span></div>;
    }
    return null;
  }

  render() {
    if (!this.state.product) return null;

    if (!this.props.brand) {
      console.error("Where's my brand?");
      console.error(this.state.product);

      return null;
    }

    let product = this.state.product;

    let minimumOrder = this.props.brand.minimum_order_amount_cents;
    if (minimumOrder) {
      minimumOrder = 'Minimum $' + parseFloat(minimumOrder / 100).toFixed(0);
    }

    if (!minimumOrder) {
      minimumOrder = 'No minimum';
    }

    let wholesaleData = this.wholesaleInfo();
    let retailContents =
      <div className="outer-wrapper">
        <div className="inner-wrapper">
          <div
            className="retail-price">{wholesaleData.retail_price && "Retail Price " + wholesaleData.retail_price}</div>
          <div className="case-size">
            {wholesaleData.collection_size && wholesaleData.collection_size + ' Items'}
            {wholesaleData.unit_multiplier && 'Case Size ' + wholesaleData.unit_multiplier}
          </div>
        </div>
      </div>;

    const brandBlock =
      <Link className="brand-block" to={`/retailer/${this.props.retailerToken}/brand/${this.props.brand.token}`}>
        <div className="maker">Maker</div>
        <div className="brand-info-contents">
          <h3 className="name">{this.props.brand.name}</h3>
          <div className="minimum">{minimumOrder}</div>
        </div>
      </Link>;

    let productError = false;
    if (!this.state.product.items) {
      productError = !this.state.product || !this.state.product.options || this.state.product.options.length <= 0;
    }

    let classNames = ['marketplace-product'];
    if (productError) {
      classNames.push('product-error');
    }

    if (productError && !this.props.isEmployee) {
      return null;
    }

    if (this.props.className) classNames.push(this.props.className);
    if (this.props.minimize) classNames.push('minimized');

    return (
      <div className={classNames.join(' ')}>
        <Link className="product-block"
              to={this.props.generateProductUrl ? this.props.generateProductUrl(this.state.product) : null}>
          <MarketplaceImage imageList={this.imageList(product)}/>
          {this.extraContent()}
          <div className="retail-overlay">{retailContents}</div>
          <div className="product-line line flex">
            <h2 className="product-name inline">{product.name}</h2>
            <div className="wholesale-price">{wholesaleData.wholesale_price}</div>
          </div>
        </Link>
        {brandBlock}
        <AdminPanel
          product={this.state.product}
          brand={this.state.brand}
          isEmployee={this.props.isEmployee}
          onActiveClick={this.onActiveClick}
          onManualRecommendationClick={this.onManualRecommendationClick}
        />
      </div>
    );
  }
}

const MarketplaceImage = ({imageList}) => {
  if (!Array.isArray(imageList) || imageList.length === 0) return <div className="image no-image"/>;
  let image = imageList[0];

  let classNames = ['image'];
  if (image.width && image.height) {
    let aspectRatio = image.width / image.height;

    if (aspectRatio > marketplaceImageAspectRatio) {
      classNames.push('landscape');
    } else if (aspectRatio < marketplaceImageAspectRatio) {
      classNames.push('portrait');
    }
  }

  return (
    <div className={classNames.join(' ')}>
      <img
        role="presentation"
        src={optimizeImageUrl(image, marketplaceImageWidth, marketplaceImageHeight)}
      />
    </div>
  );
};

const AdminPanel = ({product, brand, isEmployee, onActiveClick, onManualRecommendationClick}) => {
  if (!isEmployee) return null;

  let isActive = !!product.active;

  let isManualRecommendation = !!product.manual_recommendation;
  let manualRecommendation = (
    <p>
      <span onClick={onManualRecommendationClick}>Manual recommendation</span>
      <input className="checkbox inline"
             type="checkbox"
             style={{cursor: 'pointer'}}
             onChange={onManualRecommendationClick}
             checked={isManualRecommendation}/>
    </p>
  );

  let recommenderNames = null;
  if (product.recommenders) {
    // Make sure the elements are unique and remove manual as it's displayed separately above.
    let recommendationSet = new Set(product.recommenders);
    recommendationSet.delete('MANUAL');
    recommenderNames = <p><span>{Array.from(recommendationSet).join(', ')}</span></p>;
  }

  let likesAndCreationYear = null;
  let hasEmailHeroImageIcon = null;
  let reorderRate = null;
  let commission = null;
  if (brand) {
    const totalLikes = simplifyLargeNumber(brand.likes) || '-';
    let established = brand.creation_year || '-';
    likesAndCreationYear = <div>{totalLikes}<FontAwesome name="heart"/> Established: {established}</div>
    hasEmailHeroImageIcon = brand.email_hero_image ? <FontAwesome name="envelope"/> : null;
    if (brand.reorder_rate) {
      reorderRate = <div>Reorder rate: {Math.floor(brand.reorder_rate * 100) + '%'}</div>;
    }
    if (brand.commission_bps) {
      commission = <div>Commission: {parseFloat(brand.commission_bps / 100).toFixed(0)}%</div>
    }
  }

  return (
    <div className="admin">
      <p>
        <span onClick={onActiveClick}>Active</span>
        <input className="checkbox inline"
               type="checkbox"
               style={{cursor: 'pointer'}}
               onChange={onActiveClick}
               checked={isActive}/>
      </p>
      <p>
        <Link to={`/admin/brand/${brand.token}/product/${product.token}/edit`}>Edit Product</Link>
      </p>
      {manualRecommendation}
      {recommenderNames}
      {likesAndCreationYear}
      {hasEmailHeroImageIcon}
      {reorderRate}
      {commission}
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./src/components/Marketplace/MarketplaceProduct.js
 **/